<template>
    <div>
        <vs-popup title="Atualizar Produtos" 
            :button-close-hidden="false" 
            :active.sync="isActive"
            @close="close()"
            id="update-products-popup"
        > 
            <div>
                <div class="flex items-center justify-end">
                    <vs-input 
                      v-model="search" 
                      class="py-5 mr-4" 
                      icon="search" 
                      placeholder="Pesquisar" 
                      type="text"
                      style="width: 450px;"
                    />

                    <vs-dropdown vs-trigger-click style="cursor:pointer;" >
                        <vs-button
                            type="border"
                            class="btn-drop px-3 attendance-span mr-4 erp-drop pl-4 "
                            icon="expand_more"
                            icon-after
                            style="border-radius: 22px;"
                        >
                        <span style="font-size:14px;">
                            {{ this.selectedErp ? this.selectedErp.name : 'Selecione o ERP' }}
                        </span>
                        
                        </vs-button>

                        <vs-dropdown-menu class="erp-drop-menu text-center">
                            
                            <vs-dropdown-item class="erp-drop-item" @click="changeErpName('Selecione o ERP', null, null, null)" @touchstart.prevent="changeErpName('Selecione o ERP', null, null, null)">
                                <span>Não Vinculados</span>
                            </vs-dropdown-item>
                            
                            <vs-dropdown-item  
                                v-for="erp in erpList" class="erp-drop-item" 
                                @click="changeErpName(erp.corporate_name, erp.id, erp.erp_id, erp.erp_name)" 
                                @touchstart.prevent="changeErpName(erp.corporate_name, erp.id, erp.erp_id, erp.erp_name)"
                                :key="erp.id"
                            >
                                <span>{{ erp.corporate_name }}</span>
                            </vs-dropdown-item>

                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <vs-button 
                        v-if="selectedErp.id" 
                        @click="syncAllProducts" 
                        color="primary" 
                        type="filled"
                        class="ml-4"
                    >
                        Sincronizar Todos
                    </vs-button>
                </div>
                <div>
                    <vs-table :data="products" noDataText="Sem dados disponíveis" >
                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between m-2">
                            <div class="flex flex-wrap-reverse items-center">
                            <vs-dropdown vs-trigger-click class="cursor-pointer">
                                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bgcursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ page }} - {{ totalPages }} de {{ totalItems }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                                </div>
                                <vs-dropdown-menu>
                                <vs-dropdown-item @click="limit = 4">4</vs-dropdown-item>
                                <vs-dropdown-item @click="limit = 10">10</vs-dropdown-item>
                                <vs-dropdown-item @click="limit = 15">15</vs-dropdown-item>
                                <vs-dropdown-item @click="limit = 20">20</vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                            </div>
                        </div>
                        <template slot="thead">
                            <vs-th>Nome</vs-th>
                            <vs-th>Quantidade</vs-th>
                            <vs-th>EAN</vs-th>
                            <vs-th>Preço</vs-th>
                            <vs-th>Preço com Desconto</vs-th>
                            <vs-th>Ações</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="item.id" v-for="(item, index) in data">
                                <vs-td class="product-name font-medium truncate">{{ item.name }}</vs-td>
                                <vs-td class="product-name font-medium truncate">{{ item.amount }}</vs-td>
                                <vs-td class="product-name font-medium truncate">{{ item.bar_code }}</vs-td>
                                <vs-td class="product-name font-medium truncate">R$ {{ item.price }}</vs-td>
                                <vs-td class="product-name font-medium truncate">R$ {{ item.discount_price }}</vs-td>
                                <vs-td>
                                    <feather-icon
                                        @click="updateProduct(item, index)"
                                        svgClasses="stroke-current  w-5 h-5 hover:text-primary" 
                                        class="ml-3 cursor-pointer " 
                                        icon="RefreshCwIcon"
                                    />
                                </vs-td>
                            </vs-tr>
                        </template>
                        <template slot="empty">
                            <div class="empty-state">
                            <div class="title">Nenhuma solicitação encontrada</div>
                            <div class="subtitle">Clique em “Nova Solicitação” para iniciar um fluxo ou atualize para sincronizar.</div>
                            </div>
                        </template>
                        </vs-table>

                    <vs-pagination
                        v-if="totalPages > 1"
                        class="mt-4"
                        :max="7"
                        :total="totalPages"
                        v-model="page"
                    />
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    import erpHttp from './../../http/requests/erps/index';
    import productHttp from './../../http/requests/products/index';
    import { mapGetters } from 'vuex';
    import debounce from 'lodash/debounce';

    export default {
        data() {
            return {
                selectedErp: {
                    id: null,
                    erp_id: null,
                    erp_name: null,
                    name: 'Selecione o ERP'
                },
                erpList: [],
                search: '',
                debouncedSearch: null,
                totalPages: 0,
                totalItems: 0,
                page: 1,
                products: [],
                limit: 4,
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            tenantName: {
                type: String,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        methods: {
            close(){
                this.$emit('isActiveFalse');
            },
            fetchErps() {
                erpHttp.getAllErps(this.tenantName, this.token)
                    .then(response => {
                        this.erpList = response.data;
                    })
                    .catch(error => {
                        console.error('Erro ao buscar ERPs:', error);
                    });
            },
            changeErpName(name, id, erp_id, erp_name) {
                this.selectedErp = { name, id, erp_id, erp_name };
            },
            fetchProducts() {
                if (!this.selectedErp.id) {return;}
                productHttp.getProducts(this.tenantName, this.token, this.selectedErp.id, this.search, this.page, this.limit,)
                    .then(response => {
                        this.products = response.data.items;
                        this.totalPages = response.data.total_pages;
                        this.totalItems = response.data.total_items;
                    })
                    .catch(error => {
                        console.error('Erro ao buscar produtos:', error);
                    });
            },
            updateProduct(product, index) {
                productHttp.updateProductErpInfos(this.tenantName, this.token, product.integration_id, product.erp_id)
                    .then(response => {
                        this.products[index] = response.data[0];
                        this.$forceUpdate()
                    })
                    .catch(error => {
                        console.error('Erro ao buscar produtos:', error);
                    });
            },
            syncAllProducts() {
                erpHttp.erpProductIntegration(this.tenantName, this.token, this.selectedErp.id)
                    .then(response => {
                        this.$vs.notify({
                            title: 'Sucesso',
                            text: "Os produtos estão sendo sincronizados. Isso pode levar alguns minutos dependendo da quantidade de produtos.",
                            color: 'success'
                        });
                       
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: 'Erro',
                            text: error.response ? error.response.data : 'Erro desconhecido',
                            color: 'danger'
                        });
                    });
            },
            searchFilter(val) {
                if (val) {
                    this.fetchProducts();
                    return;
                }
            }
        },
        watch: {
            isActive(value) {
                if (value) {
                    return this.fetchErps();
                }
                this.selectedErp = {
                    id: null,
                    erp_id: null,
                    erp_name: null,
                    name: 'Selecione o ERP'
                };
                this.search = '';
                this.page = 1
                this.totalPages = 0
                this.totalItems = 0
            },
            search(val) {
                if (this.debouncedSearch) {
                    this.debouncedSearch(val);
                }
            },
            selectedErp(value) {
                if (value && value.id === null) {
                    this.products = [];
                    return;
                }
                this.fetchProducts();
            },
            page() {
                this.fetchProducts();
            },
            limit() {
                this.fetchProducts();
            },
        },
        computed: {
            ...mapGetters([
                'token'
            ])
        },
        created(){
            // set up debounced search handler
            this.debouncedSearch = debounce((val) => {
                this.searchFilter(val);
            }, 700);

            this.$events.on('closeSyncProducts', this.close);
        },
        beforeDestroy() {
            this.$events.off('closeSyncProducts', this.close);
        }
    }
</script>

<style lang="scss">
.erp-drop-menu {
    z-index: 999999999 !important;
}
#update-products-popup{
    .vs-popup {
        width: 1210px !important;
    }
}
</style>